/**
 * Count Visible Points Utility
 * Binary search to count points in visible range (O(log n))
 */

export function countVisiblePoints(data: number[], xMin: number, xMax: number): number {
  if (data.length === 0) return 0;

  // Find first index >= xMin
  let left = 0;
  let right = data.length - 1;
  let startIdx = data.length;

  while (left <= right) {
    const mid = Math.floor((left + right) / 2);
    if (data[mid] >= xMin) {
      startIdx = mid;
      right = mid - 1;
    } else {
      left = mid + 1;
    }
  }

  // Find last index <= xMax
  left = 0;
  right = data.length - 1;
  let endIdx = -1;

  while (left <= right) {
    const mid = Math.floor((left + right) / 2);
    if (data[mid] <= xMax) {
      endIdx = mid;
      left = mid + 1;
    } else {
      right = mid - 1;
    }
  }

  return endIdx >= startIdx ? endIdx - startIdx + 1 : 0;
}
